import {ThemeProvider} from 'next-themes';
import * as React from 'react';

export function ColorModeProvider(props: any) {
  return <ThemeProvider attribute="class" disableTransitionOnChange {...props} defaultTheme="dark" />;
}
